import { AxiosRequestConfig, AxiosResponse } from "axios";
import { Api } from "./Api";
import { apiConfig } from "../config/apiConfig";
import { Spouse } from "../model/spouse";
import { SpouseResponse } from "../model/response";

class SpouseApi extends Api {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig);
  }

  public getSpouse = () => this.get("/spouse") as Promise<AxiosResponse<SpouseResponse>>;

  public createSpouse = (payload: Spouse) => this.post("/spouse", payload);

  public updateSpouse = (payload: Spouse) => this.put("/spouse", payload);

  public deleteSpouse = () => this.delete("/spouse");
}

export const spouseApi = new SpouseApi(apiConfig);
